import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDiamondTransactions } from '../../redux/actions/pack';
import styles from './transaction.module.css';

const PackHistory = () => {
  const dispatch = useDispatch();
  const {diamondTransactions} = useSelector(
    (state) => state.pack
  );
  const packages = diamondTransactions.map((diamond) => {
    return {
      name: `Pembelian ${diamond.pack.amount} Diamonds - IDR ${diamond.pack.price}`,
      date: `${new Date(diamond.updatedAt).toLocaleDateString('en-US')}`,
      amount: diamond.pack.amount,
      price: diamond.pack.price,
      updatedAt: diamond.updatedAt,
    };
  });

  useEffect(() => {
    dispatch(getDiamondTransactions());
  }, [dispatch]);

  return (
    <div className={styles.listWrapper}>
      {packages.map((pack, key) => {
        return (
          <div className={styles.itemWrapper} key={key}>
            <div className={styles.detail}>
              <h3 className={styles.title}>{pack.name}</h3>
              <span className={styles.date}>{pack.date}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PackHistory;
